import { useSelector } from 'react-redux';
import { I18n } from 'i18n-js';

import id from './locales/id.json';
import en from './locales/en.json';
import vi from './locales/vi.json';
import my from './locales/my.json';

const i18n = new I18n({
    id,
    en,
    my
});

i18n.enableFallback = true;

export const useTranslation = () => i18n.t.bind(i18n);

export default i18n;
